import Core from '@mediaplatform/basketball-sdk';
import { BasketballSDKOptions } from '../../packages/types';

// TODO test the  default values
// TODO ask PO for the lang property in the options
export default ({
  dataConfigApiUrl,
  dataConfigStandingsApiUrl,
  dataConfigPlayoffApiUrl,
  dataConfigApiKey,
  dataConfigLang,
  dataConfigProject,
  dataConfigOddClient,
  dataConfigTimezone,
  dataConfigCompetitionList,
}: BasketballSDKOptions) => {
  return new Core({
    dataConfigApiUrl: dataConfigApiUrl,
    dataConfigStandingsApiUrl: dataConfigStandingsApiUrl,
    dataConfigPlayoffApiUrl: dataConfigPlayoffApiUrl,
    dataConfigApiKey: dataConfigApiKey,
    dataConfigLang: dataConfigLang,
    dataConfigProject: dataConfigProject,
    dataConfigOddClient: dataConfigOddClient,
    dataConfigTimezone: dataConfigTimezone,
    dataConfigCompetitionList: dataConfigCompetitionList,
  });
};
